import { Button, BoxProps, ButtonProps, Box } from "@chakra-ui/react";

type Props = BoxProps & ButtonProps;

export default function MaybeButtonLink({ onClick, ...rest }: Props) {
  if (onClick) {
    return (
      <Button
        variant="link"
        onClick={onClick}
        display="inline"
        textAlign="inherit"
        {...rest}
      />
    );
  }

  return <Box as="span" {...rest} />;
}
